import React from 'react';
import { Text, View } from 'react-native';
import { useI18n } from '@shared/i18n/useI18n';

export const DocumentNewTag = () => {
    const { t } = useI18n();

    return (
        <View className="rounded-full bg-error-500 px-[14px] py-[2px]">
            <Text className="text-md font-bold leading-[18px] text-white">{t('documents.newTag')}</Text>
        </View>
    );
};
